import {NgModule} from '@angular/core';
import {CommonModule,  Location, LocationStrategy, PathLocationStrategy} from '@angular/common';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatPseudoCheckboxModule } from '@angular/material/core';
import { MatRadioModule } from '@angular/material/radio';
import { FormsModule } from '@angular/forms';
import {TranslateModule} from '@ngx-translate/core';
import { SearchPipeModule, SafePipeModule } from '@signature-it/ngx-generic/pipes';
import { AccordionModule } from 'ngx-bootstrap/accordion';
import { FilterMenuDirectiveModule } from '@signature-it/ngx-catalogue/directives';
import { FiltersComponent } from './filters.component';
import {NgScrollbarModule} from "ngx-scrollbar";
import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { MatSelectModule } from '@angular/material/select';

@NgModule({
    declarations: [
        FiltersComponent
    ],
    imports: [
        AccordionModule.forRoot(),
        CommonModule,
        FormsModule,
        TranslateModule,
        SearchPipeModule,
        FilterMenuDirectiveModule,
        MatCheckboxModule,
        MatPseudoCheckboxModule,
        MatRadioModule,
        NgScrollbarModule,
        SafePipeModule,
        NgbDropdownModule,
        MatSelectModule
    ],
    providers: [Location, {provide: LocationStrategy, useClass: PathLocationStrategy}],
    exports: [FiltersComponent]
})
export class FiltersModule_Catalogue {}
